/**
 * 秘文字レイヤーの画像。**全ステージ共通の素材**であり、ステージ設定には含まれない
 * （`05-database-schema.md` §3）。いまは仮の素材で、最終的な意匠は差し替える。
 *
 * ランタイム（`main.ts` の盤面組み立て）とビルド（`src/build/pages.ts` の preload ヒント。
 * JS 起動後にしか発見されない本画像を先読みさせ、LCP を縮める。NFR-001 / TK-023）の
 * 両方が参照するため、単独モジュールに置いて URL の二重管理を避ける。
 */
export const SECRET_IMAGE_URL = '/placeholder/secret.svg';
